import Echo from 'laravel-echo';

import Pusher from 'pusher-js';
window.Pusher = Pusher;

function createEcho(token) {
  return new Echo({
      broadcaster: 'reverb',
      key: '2lcvfmkzolfhipepz93c',
      wsHost: 'localhost',
      wsPort: 8081,
      wssPort: 8081,
      forceTLS: false,
      enabledTransports: ['ws', 'wss'],
      // authEndpoint: 'http://localhost:8080/broadcasting/auth', // onde o Laravel está
      auth: {
          headers: {
              Authorization: `Bearer ${token}`
          }
      }
  });
}


// window.Echo = createEcho('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vbG9jYWxob3N0OjgwMDAvYXBpL3YxL2xvZ2luIiwiaWF0IjoxNzQ0NTI5Mjc5LCJleHAiOjE3NDQ2MTU2NzksIm5iZiI6MTc0NDUyOTI3OSwianRpIjoiUUpFV1d4dms3SEc2TmV1WCIsInN1YiI6IjEiLCJwcnYiOiIyM2JkNWM4OTQ5ZjYwMGFkYjM5ZTcwMWM0MDA4NzJkYjdhNTk3NmY3In0.7KzkgrSt_sEDD-oDoziL00imhJZswa5r1KDp2Mr818s')


export default createEcho;


// Criar uma forma de instanciar o Echo com o token do usuário logado


